import { render, staticRenderFns } from "./StudentViewUserPlanCard.vue?vue&type=template&id=2cac6817&"
import script from "./StudentViewUserPlanCard.vue?vue&type=script&lang=js&"
export * from "./StudentViewUserPlanCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports